// extracted by mini-css-extract-plugin
export default {"box":"model-actions_box__oJIW0","action":"model-actions_action__LG3kX","download":"model-actions_download__2TVHL","dot":"model-actions_dot__bO48q","link":"model-actions_link__uW3jk"};